module.exports = {
	"title": {
		"artist": "Hören Sie {artistName} auf Qobuz",
		"album": "Hören Sie {albumName} von {artistName} auf Qobuz",
		"track": "Hören Sie {trackName} von {artistName} auf Qobuz",
		"playlist": "Hören Sie die Playlist {playlistName} von {ownerName} auf Qobuz",
		"focus": "Lesen Sie diesen Panorama-Artikel auf Qobuz"
	},
	"buttons": {
		"listen": "Auf Qobuz hören",
		"buy": "Im Onlinestore kaufen",
		"download": "Qobuz für Mac/PC herunterladen",
		"readmore": "Mehr lesen",
		"showless": "Weniger anzeigen",
		"showmore": "Mehr sehen",
		"readfocus": "Diesen Panorama-Artikel auf Qobuz lesen",
		"seeSubscribes": "Die Streaming-Abonnements sehen"
	},
	"infos": {
		"trackCount": "{count} Tracks",
		"diskCount": "{count} Discs",
		"duration": {
			"long": "{hours}h {minutes}m",
			"short": "{minutes}m {seconds}s"
		},
		"playlist": {
			"private": "Privat",
			"public": "Öffentlich"
		},
		"hires": "Hohe Qualität"
	},
	"share": {
		"twitter": {
			"track": "Hören Sie {title} von {artist} auf Qobuz",
			"album": "Hören Sie {title} von {artist} auf Qobuz",
			"artist": "Hören Sie {artist} auf Qobuz",
			"playlist": "Hören Sie {playlist} von {owner} auf Qobuz",
			"focus": "Lesen Sie diesen Panorama-Artikel auf Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} von {artist} finden Sie auf Qobuz !",
				"body": "Höre dir {title} von {artist} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} von {artist} finden Sie auf Qobuz !",
				"body": "Höre dir {title} von {artist} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} ist bei Qobuz !",
				"body": "Höre dir {artist} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} von {owner} finden Sie auf Qobuz!",
				"body": "Höre dir {playlist} von {owner} mit Qobuz in bester Soundqualität an: {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			},
			"focus": {
				"subject": "{title}",
				"body": "Lesen Sie {url}\n\nQobuz ist der erste Musikservice, der Streaming und Downloads in hoher Soundqualität anbietet.\nMehr Informationen sowie Abonnements auf Qobuz.com\n\n"
			}
		}
	},
	"tracklist": {
		"title": {
			"track": "Track",
			"album": "Albumtitel",
			"artist": "Die besten Tracks",
			"artist_albums": "Alben",
			"playlist": "Tracks der Playlist"
		},
		"header": {
			"number": "#",
			"name": "Titel",
			"album": "Album",
			"artist": "Künstler",
			"time": "Laufzeit",
			"label": "Label"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Kein Track verfügbar"
	},
	"focus": {
		"from": "Von {author}",
		"albumOverlay": " - {releaseYear} - {genre}"
	},
	"playlist": {
		"from": "Von {author}"
	},
	"notifications": {
		"subscribe": "Sie müssen ein Abonnement abschließen, um die Musik mit Qobuz streamen zu können.",
		"purchase": "Sie können diesen Track kaufen, um ihn abzuspielen und auf Ihre App zu importieren."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/de.json
// module id = 447
// module chunks = 0